import { CrudModel } from '@ngx-ivengi/crud';
import { priceType } from '../price/price.enum';

export class Calculation extends CrudModel {
  public date: Date = new Date();
  public file: FileList;
  public priceListTypes: string[] = [priceType.SALES, priceType.PURCHASE, priceType.TIME];

  public setDate(date: Date): this {
    if (date instanceof Date) {
      this.date = date;
    }
    return this;
  }

  public setFile(file: FileList): this {
    if(file instanceof FileList) {
      this.file = file;
    }
    return this;
  }

  public fromResponse(response: any): void {
    // Calculations don't have a persistent layer. So we don't need to implement this method.
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/calculation/calculation.model.ts